var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7516 17.8401C33.7516 16.581 33.6443 15.6623 33.4123 14.7095H18.323V20.3921H27.1801C27.0016 21.8043 26.0373 23.931 23.8944 25.3601L23.8643 25.5504L28.6353 29.0718L28.9658 29.1033C32.0015 26.4321 33.7516 22.5018 33.7516 17.8401Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.322 32.8125C22.6612 32.8125 26.304 31.4513 28.9648 29.1034L23.8933 25.3603C22.5362 26.262 20.7148 26.8915 18.322 26.8915C14.072 26.8915 10.4649 24.2204 9.17908 20.5284L8.99061 20.5436L4.02972 24.2016L3.96484 24.3735C6.60766 29.3756 12.0362 32.8125 18.322 32.8125Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17996 20.5284C8.84068 19.5757 8.64433 18.5548 8.64433 17.4999C8.64433 16.445 8.84068 15.4242 9.16211 14.4715L9.15312 14.2685L4.13005 10.5518L3.96571 10.6263C2.87647 12.702 2.25146 15.0329 2.25146 17.4999C2.25146 19.967 2.87647 22.2978 3.96571 24.3735L9.17996 20.5284Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3221 8.10829C21.3399 8.10829 23.3755 9.3503 24.5363 10.3882L29.072 6.16875C26.2864 3.70174 22.6613 2.1875 18.3221 2.1875C12.0363 2.1875 6.60768 5.62428 3.96484 10.6263L9.16126 14.4715C10.465 10.7795 14.0721 8.10829 18.3221 8.10829Z",
    fill: "#EB4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.32bf9dee98732c3f681f8f93389088bb.svg";
export { ForwardRef as ReactComponent };